/* ============================================================
   OMA ORGANICS — SHOPIFY THEME JS
   ============================================================ */

// ===================== NAV SCROLL =====================
window.addEventListener('scroll', () => {
  const nav = document.getElementById('nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 12);
});

// ===================== MOBILE MENU =====================
function toggleMobMenu() {
  document.getElementById('mobMenu').classList.toggle('on');
}
function closeMobMenu() {
  document.getElementById('mobMenu').classList.remove('on');
}

// ===================== ESCAPE KEY =====================
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCart();
    closeSearch();
    closeQuiz();
    closeMobMenu();
  }
});

// ===================== SCROLL REVEAL =====================
function initReveals() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  document.documentElement.classList.add('js-anim');
  document.querySelectorAll('.reveal:not(.visible)').forEach((el) => obs.observe(el));
}
initReveals();

// Re-init on page transitions
document.addEventListener('shopify:section:load', initReveals);

// ===================== HERO IMAGE CAROUSEL =====================
(function () {
  const imgs = document.querySelectorAll('.hero-prod-img');
  if (imgs.length < 2) return;
  let cur = 0;
  setInterval(() => {
    imgs[cur].classList.remove('hero-active');
    cur = (cur + 1) % imgs.length;
    imgs[cur].classList.add('hero-active');
  }, 4000);
})();

// ===================== CART (AJAX API) =====================
function toggleCart() {
  const drawer = document.getElementById('cartDrawer');
  if (drawer.classList.contains('on')) {
    closeCart();
  } else {
    openCart();
  }
}

function openCart() {
  var chatEl=document.getElementById("oma-chat-widget"); if(chatEl)chatEl.style.display="none";
  document.getElementById('cartOverlay').classList.add('on');
  document.getElementById('cartDrawer').classList.add('on');
  refreshCart();
}

function closeCart() {
  var chatEl=document.getElementById("oma-chat-widget"); if(chatEl)chatEl.style.display="";
  document.getElementById('cartOverlay').classList.remove('on');
  document.getElementById('cartDrawer').classList.remove('on');
}

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCartDrawer(cart);
    sdkCheckCart(cart);
    updateCartCount(cart.item_count);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function updateCartCount(count) {
  const el = document.getElementById('cartCount');
  if (el) {
    el.textContent = count;
    el.classList.toggle('show', count > 0);
  }
}

function renderCartDrawer(cart) {
  const body = document.getElementById('cartBody');
  const total = document.getElementById('cartTotal');
  if (!body) return;

  if (cart.items.length === 0) {
    body.innerHTML = '<div class="cart-empty">Your cart is empty.<br>Good things are waiting.</div>';
  } else {
    body.innerHTML = cart.items.map((item) => {
      const imgSrc = item.image ? getSizedImageUrl(item.image, '104x') : '';
      const imgHtml = imgSrc
        ? `<img src="${imgSrc}" alt="${escapeHtml(item.product_title)}">`
        : `<div style="font-size:0.58rem;color:var(--clay);text-align:center;padding:6px;">${escapeHtml(item.product_title)}</div>`;
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      var _props = item.properties || {};
      var _pk = Object.keys(_props).filter(function (k) { return k.charAt(0) !== '_' && _props[k]; });
      const propsHtml = _pk.length ? '<div class="ci-props">' + _pk.map(function (k) { return escapeHtml(_props[k]); }).join(' · ') + '</div>' : '';
      const isKit = item.handle === 'scent-discovery-kit';
      return `
        <div class="ci" data-key="${item.key}">
          <div class="ci-img">${imgHtml}</div>
          <div>
            <div class="ci-name">${escapeHtml(item.product_title)}</div>
            <div class="ci-meta">${escapeHtml(variantTitle)}</div>
            ${propsHtml}
            <div class="ci-qty">
              <button onclick="updateCartItem(this.closest('.ci').dataset.key, ${item.quantity - 1})">&minus;</button>
              <span>${item.quantity}</span>
              <button onclick="updateCartItem(this.closest('.ci').dataset.key, ${item.quantity + 1})">+</button>
            </div>
          </div>
          <div class="ci-right">
            <div class="ci-price">${formatMoney(item.final_line_price)}</div>
            <button class="ci-rm" onclick="updateCartItem(this.closest('.ci').dataset.key, 0)">Remove</button>
          </div>
        </div>`;
    }).join('');
  }

  if (total) {
    total.textContent = formatMoney(cart.total_price);
  }

  var discEl = document.getElementById('cartDiscounts');
  if (discEl) {
    var agg = {}, order = [];
    function addD(title, amt) { if (!amt) return; title = title || 'Discount'; if (agg[title] == null) { agg[title] = 0; order.push(title); } agg[title] += amt; }
    (cart.cart_level_discount_applications || []).forEach(function (a) { addD(a.title, a.total_allocated_amount); });
    (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (al) { addD(al.discount_application && al.discount_application.title, al.amount); }); });
    discEl.innerHTML = order.map(function (t) {
      return '<div class="cart-disc-row"><span>' + escapeHtml(t) + '</span><span>−' + formatMoney(agg[t]) + '</span></div>';
    }).join('');
  }

  // Dynamic upsell: rebuild based on current cart contents
  renderDsUpgrade(cart);
  renderCartUpsell(cart);
  renderCartWishlist();
  updateBundleNudge(cart);
  updateShipNudge(cart);
}



function updateShipNudge(cart) {
  var el = document.getElementById('shipNudge'); if (!el) return;
  var n = cart.item_count || 0; if (n === 0) { el.hidden = true; return; }
  el.hidden = false; var THRESH = 7500;
  var merch = (cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
  if (merch >= THRESH) { el.innerHTML = '<span class="ok">\u2713 Free shipping unlocked</span>'; }
  else { var gap = THRESH - merch; var pct = Math.min(100, Math.round(merch * 100 / THRESH));
    el.innerHTML = "You're " + formatMoney(gap) + ' from free shipping<div class="ship-track"><div class="ship-fill" style="width:' + pct + '%"></div></div>'; }
}
function updateBundleNudge(cart) {
  var el = document.getElementById('bundleNudge'); if (!el) return;
  var n = cart.item_count || 0;
  if (n === 0) { el.hidden = true; return; }
  el.hidden = false;
  if (n >= 3) { el.classList.add('unlocked'); el.innerHTML = '\u2726 Bundle unlocked \u2014 15% off everything at checkout'; }
  else { el.classList.remove('unlocked'); var left = 3 - n; el.innerHTML = 'Add ' + left + ' more item' + (left === 1 ? '' : 's') + ' \u2014 unlock 15% off your whole order'; }
}

function dsVariants() {
  try { var data = JSON.parse(document.getElementById('quiz-products-data').textContent);
    var p = data.find(function (x) { return x.handle === 'good-scents-discovery-set'; }); if (!p) return null;
    var full = p.variants.find(function (v) { return /full/i.test(v.title); });
    var best = p.variants.find(function (v) { return /best/i.test(v.title); });
    return full && best ? { full: full, best: best } : null; } catch (e) { return null; }
}
function renderDsUpgrade(cart) {
  var el = document.getElementById('dsUpgrade'); if (!el) return;
  var dv = dsVariants(); if (!dv) { el.hidden = true; return; }
  var same = function (a, b) { return String(a) === String(b); };
  var line = cart.items.find(function (i) { return same(i.variant_id, dv.best.id); });
  var hasFull = cart.items.some(function (i) { return same(i.variant_id, dv.full.id); });
  if (!line || hasFull) { el.hidden = true; return; }
  var diff = (dv.full.price - dv.best.price) / 100;
  var count = 10 - 4;
  var d = (diff % 1 ? diff.toFixed(2) : diff);
  el.innerHTML = '<span><b>Get all 10 scents</b><br><span style="font-size:.72rem;color:var(--stone,#7a7365)">the full collection &mdash; best value</span></span>' +
    '<button type="button" onclick="upgradeDiscovery(\'' + line.key + '\',' + dv.full.id + ')">Upgrade &middot; +$' + d + '</button>';
  el.hidden = false;
}
async function upgradeDiscovery(lineKey, fullVariantId) {
  try {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: lineKey, quantity: 0 }) });
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: fullVariantId, quantity: 1 }] }) });
    refreshCart();
  } catch (e) { console.error('upgrade error', e); }
}

function renderCartUpsell(cart) {
  var upsellEl = document.getElementById('cartUpsell');
  var scrollEl = document.getElementById('cartUpsellScroll');
  if (!upsellEl || !scrollEl) return;
  if (!cart.items.length) { upsellEl.style.display = 'none'; return; }
  var data = [];
  try { data = JSON.parse(document.getElementById('quiz-products-data').textContent); } catch (e) {}
  if (!data.length) { upsellEl.style.display = 'none'; return; }
  var byHandle = {}; data.forEach(function (p) { byHandle[p.handle] = p; });
  function cat(type) { type = (type || '').toLowerCase();
    if (type.indexOf('perfume') > -1 || type.indexOf('discovery') > -1) return 'scents';
    if (type.indexOf('body') > -1) return 'body';
    if (type.indexOf('face') > -1) return 'face';
    if (type.indexOf('gel') > -1 || type.indexOf('steamer') > -1 || type.indexOf('candle') > -1 || type.indexOf('shower') > -1) return 'ssf';
    return null; }
  function scentKey(h) { var keys = ['amalfi', 'emerald', 'imperial', 'mod', 'uto', 'ifuru', 'ikuku', 'ahihia', 'ubi', 'solaire', 'sahel'];
    for (var i = 0; i < keys.length; i++) if (h.indexOf(keys[i]) > -1) return keys[i] === 'sahel' ? 'uto' : keys[i]; return null; }
  var inCart = {}, cats = {}, scents = {};
  cart.items.forEach(function (it) { inCart[it.handle] = 1; var p = byHandle[it.handle]; var c = cat(p ? p.type : it.product_type); if (c) cats[c] = 1; var k = scentKey(it.handle); if (k) scents[k] = 1; });
  function pick(cands) { for (var i = 0; i < cands.length; i++) { var p = byHandle[cands[i]]; if (p && !inCart[cands[i]] && p.variants && p.variants.some(function (v) { return v.available; })) return p; } return null; }
  var k = Object.keys(scents)[0] || '';
  var PLAN = {
    scents: { uto: ['good-scents-discovery-set', 'uto'], amalfi: ['good-scents-discovery-set', 'solaire'], emerald: ['good-scents-discovery-set', 'mod-perfume'], mod: ['good-scents-discovery-set', 'mod-perfume'], imperial: ['good-scents-discovery-set', 'ifuru'], _: ['good-scents-discovery-set', 'uto'] },
    body: { uto: ['uto-body-oil', 'sahel'], mod: ['mod-body-oil', 'sahel'], amalfi: ['amalfi-sunrise-body-oil', 'sahel'], imperial: ['imperial-garden-body-oil', 'sahel'], ifuru: ['imperial-garden-body-oil', 'sahel'], ubi: ['imperial-garden-body-oil', 'sahel'], _: ['sahel', 'uto-body-oil'] },
    face: { _: ['grace', 'resolve'] },
    ssf: { amalfi: ['amalfi-sunrise-shower-gel', 'amalfi-sunrise-shower-steamers'], mod: ['mod-shower-gel'], emerald: ['emerald-dream-shower-steamers', 'mod-shower-gel'], imperial: ['imperial-garden-shower-gel'], ifuru: ['imperial-garden-shower-gel'], ubi: ['imperial-garden-shower-gel'], uto: ['amalfi-sunrise-shower-steamers', 'amalfi-sunrise-shower-gel'], _: ['amalfi-sunrise-shower-gel'] } };
  var picksOrder = ['scents', 'body', 'ssf', 'face'];
  var html = '';
  picksOrder.forEach(function (c) {
    if (cats[c]) return;
    var plan = PLAN[c]; var cands = (plan[k] || plan._).concat(plan._);
    var p = pick(cands); if (!p) return;
    var v = p.variants.filter(function (x) { return x.available; })[0];
    html += '<div class="cart-upsell-card" data-handle="' + p.handle + '">' +
      '<a href="' + p.url + '" class="cart-upsell-img">' + (p.image ? '<img src="' + p.image + '" alt="">' : '') + '</a>' +
      '<div class="cart-upsell-info"><div class="cart-upsell-name">' + escapeHtml(p.title) + '</div><div class="cart-upsell-type">' + escapeHtml(p.type || '') + '</div><div class="cart-upsell-price">' + (v ? v.price_formatted : p.price_formatted) + '</div></div>' +
      '<button class="cart-upsell-add" onclick="' + (p.handle === 'good-scents-discovery-set' ? 'omaOpenDiscoveryPicker()' : 'addVariantToCart(' + (v ? v.id : p.variants[0].id) + ')') + '">+ Add</button></div>';
  });
  scrollEl.innerHTML = html;
  upsellEl.style.display = html ? '' : 'none';
}

// Inline wishlist inside the cart drawer (no separate page)
function renderCartWishlist() {
  var wrap = document.getElementById('cartWishlist');
  var list = document.getElementById('cartWishlistList');
  if (!wrap || !list) return;
  var items = [];
  try { items = (window.OmaWishlist && window.OmaWishlist.get()) || []; } catch (e) {}
  var html = '';
  items.forEach(function (p) {
    if (!p || !p.variant_id) return;
    var priceStr = (typeof p.price === 'number' && !isNaN(p.price)) ? formatMoney(p.price) : '';
    var wid = String(p.id).replace(/[^a-zA-Z0-9_-]/g, '');
    html += '<div class="cart-upsell-card" data-handle="' + (p.handle || '') + '">' +
      '<a href="' + (p.url || '#') + '" class="cart-upsell-img">' + (p.image ? '<img src="' + p.image + '" alt="">' : '') + '</a>' +
      '<div class="cart-upsell-info"><div class="cart-upsell-name">' + escapeHtml(p.title || '') + '</div>' +
      '<div class="cart-upsell-type">' + escapeHtml(p.type || '') + '</div>' +
      '<div class="cart-upsell-price">' + priceStr + '</div></div>' +
      '<button class="cart-upsell-add" onclick="' + (p.handle === 'good-scents-discovery-set' ? 'omaOpenDiscoveryPicker(\'' + wid + '\')' : 'cartWishlistAdd(' + p.variant_id + ',\'' + wid + '\')') + '">+ Add</button></div>';
  });
  list.innerHTML = html;
  wrap.style.display = html ? '' : 'none';
}
function cartWishlistAdd(variantId, wlId) {
  try { if (window.OmaWishlist && wlId) { window.OmaWishlist.remove(wlId); if (window.OmaWishlist.sync) window.OmaWishlist.sync(); } } catch (e) {}
  addVariantToCart(variantId);
}

// Keep the in-cart wishlist section live when items are hearted/un-hearted anywhere on the page
document.addEventListener('oma:wishlist:add', function () { if (typeof renderCartWishlist === 'function') renderCartWishlist(); });
document.addEventListener('oma:wishlist:remove', function () { if (typeof renderCartWishlist === 'function') renderCartWishlist(); });

// ===================== DISCOVERY SET SCENT PICKER =====================
// The discovery set is a "pick your 4 scents" product. When it's added from the wishlist or the
// "complete your ritual" upsell (no PDP picker present), open a modal so the shopper chooses 4.
var OMA_SP_SEL = [], OMA_SP_WLID = null;
function omaDsetNeed() { return (window.OMA_DSET && window.OMA_DSET.count) || 4; }
function omaOpenDiscoveryPicker(wlId) {
  var d = window.OMA_DSET;
  var modal = document.getElementById('omaScentModal');
  var grid = document.getElementById('omaSpGrid');
  if (!d || !d.variant || !modal || !grid) { if (d && d.url) location.href = d.url; return; }
  OMA_SP_WLID = wlId || null; OMA_SP_SEL = [];
  grid.innerHTML = (d.scents || []).filter(Boolean).map(function (s) {
    return '<button type="button" class="oma-sp-chip" data-scent="' + String(s).replace(/"/g, '&quot;') + '">' + escapeHtml(s) + '</button>';
  }).join('');
  omaSpUpdate();
  modal.hidden = false; try { document.documentElement.style.overflow = 'hidden'; } catch (e) {}
}
function omaSpClose() { var m = document.getElementById('omaScentModal'); if (m) m.hidden = true; try { document.documentElement.style.overflow = ''; } catch (e) {} }
function omaSpUpdate() {
  var need = omaDsetNeed();
  var c = document.getElementById('omaSpCount'); if (c) c.textContent = 'Pick ' + need + ' — ' + OMA_SP_SEL.length + ' selected';
  var a = document.getElementById('omaSpAdd'); if (a) a.disabled = OMA_SP_SEL.length !== need;
}
function omaSpConfirm() {
  var d = window.OMA_DSET, need = omaDsetNeed();
  if (!d || OMA_SP_SEL.length !== need) return;
  var props = {}; OMA_SP_SEL.forEach(function (s, i) { props['Scent ' + (i + 1)] = s; });
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: d.variant, quantity: 1, properties: props }] }) })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (OMA_SP_WLID && window.OmaWishlist) { try { window.OmaWishlist.remove(OMA_SP_WLID); if (window.OmaWishlist.sync) window.OmaWishlist.sync(); } catch (e) {} }
      omaSpClose();
      if (typeof openCart === 'function') openCart(); else if (typeof refreshCart === 'function') refreshCart();
    })
    .catch(function () { location.href = (d && d.url) || '/cart'; });
}
document.addEventListener('click', function (e) {
  var chip = e.target.closest && e.target.closest('.oma-sp-chip');
  if (chip) {
    var s = chip.getAttribute('data-scent'), idx = OMA_SP_SEL.indexOf(s);
    if (idx > -1) { OMA_SP_SEL.splice(idx, 1); chip.classList.remove('on'); }
    else if (OMA_SP_SEL.length < omaDsetNeed()) { OMA_SP_SEL.push(s); chip.classList.add('on'); }
    omaSpUpdate(); return;
  }
  if (e.target.closest && e.target.closest('[data-sp-close]')) { omaSpClose(); return; }
  if (e.target.closest && e.target.closest('#omaSpAdd')) { omaSpConfirm(); return; }
});

async function updateCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    refreshCart();
  } catch (e) {
    console.error('Cart update error:', e);
  }
}

function addVariantToCart(variantId, quantity) {
  quantity = quantity || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
  }).then(function() {
    // Immediately update cart count badge
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateCartCount(c.item_count);});
    openCart();
  }).catch(function(e) {
    console.error('Add to cart error:', e);
  });
}

// Intercept product form submission to use AJAX
document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form.action || !form.action.includes('/cart/add')) return;
  e.preventDefault();

  const formData = new FormData(form);
  var props = {};
  for (var pair of formData.entries()) { var mm = pair[0].match(/^properties\[(.+)\]$/); if (mm && pair[1]) props[mm[1]] = pair[1]; }
  const item = { id: parseInt(formData.get('id')), quantity: parseInt(formData.get('quantity') || 1) };
  if (Object.keys(props).length) item.properties = props;
  const data = { items: [item] };

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    openCart();
  } catch (e) {
    console.error('Add to cart error:', e);
  }
});

// ===================== PRODUCT PAGE HELPERS =====================
let productQty = 1;

function selectVariant(el, variantId, price) {
  document.querySelectorAll('.sz').forEach((s) => s.classList.remove('on'));
  el.classList.add('on');
  const input = document.getElementById('productVariantId');
  if (input) input.value = variantId;
  var val = document.getElementById('pdPriceVal');
  if (val && price) { val.textContent = price; var from = document.getElementById('pdFrom'); if (from) from.style.display = 'none'; }
  var img = el.getAttribute('data-variant-img');
  if (img) { if (typeof pdShowImage === 'function') pdShowImage(img); var main = document.querySelector('.pd-main img') || document.querySelector('.pd-left img'); if (main) { main.src = img; main.srcset = ''; if (typeof markPortraitPdImage === 'function') { main.addEventListener('load', function h(){ main.removeEventListener('load', h); markPortraitPdImage(); }); } } }
  var sticky = document.querySelector('.pd-sticky #pdStickyPrice'); if (sticky && price) sticky.textContent = price;
}

function changeProductQty(delta) {
  productQty = Math.max(1, productQty + delta);
  const valEl = document.getElementById('productQtyVal');
  const inputEl = document.getElementById('productQtyInput');
  if (valEl) valEl.textContent = productQty;
  if (inputEl) inputEl.value = productQty;
}

function switchPdTab(tab) {
  document.querySelectorAll('.pd-tab').forEach((t) =>
    t.classList.toggle('on', t.dataset.tab === tab)
  );
  document.querySelectorAll('.pd-tab-body').forEach((t) =>
    t.classList.toggle('on', t.dataset.tab === tab)
  );
}

function shareProduct(url, title) {
  const fullUrl = window.location.origin + url;
  if (navigator.share) {
    navigator.share({ title: title + ' \u2014 Oma Organics', url: fullUrl }).catch(function(err) {
      // AbortError is normal (user dismissed share sheet)
      if (err.name !== 'AbortError') console.log('Share error:', err);
    });
    return; // prevent any parent click handlers from firing
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(fullUrl).then(() => {
      const btn = document.querySelector('.pd-share');
      if (btn) {
        btn.classList.add('copied');
        const origHtml = btn.innerHTML;
        btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="20 6 9 17 4 12"/></svg> Link Copied';
        setTimeout(() => { btn.classList.remove('copied'); btn.innerHTML = origHtml; }, 2000);
      }
    });
  }
}

// ===================== SEARCH (Predictive) =====================
function toggleSearch() {
  const el = document.getElementById('searchOverlay');
  el.classList.toggle('on');
  if (el.classList.contains('on')) {
    setTimeout(() => document.getElementById('searchInput').focus(), 100);
  }
}

function closeSearch() {
  document.getElementById('searchOverlay').classList.remove('on');
  const input = document.getElementById('searchInput');
  if (input) input.value = '';
}

let searchDebounce;
async function doPredictiveSearch(q) {
  clearTimeout(searchDebounce);
  const res = document.getElementById('searchResults');
  if (!q.trim()) {
    res.innerHTML = '<div class="sr-empty">Start typing to search the collection.</div>';
    return;
  }
  searchDebounce = setTimeout(async () => {
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`
      );
      const data = await response.json();
      const products = data.resources.results.products || [];
      if (products.length === 0) {
        res.innerHTML = `<div class="sr-empty">No products found for "${escapeHtml(q)}"</div>`;
        return;
      }
      res.innerHTML = products.map((p) => {
        const imgHtml = p.image ? `<img src="${getSizedImageUrl(p.image, '88x')}" alt="${escapeHtml(p.title)}">` : '';
        return `
          <a class="sr-item" href="${p.url}" onclick="closeSearch()">
            <div class="sr-img">${imgHtml}</div>
            <div>
              <div class="sr-name">${escapeHtml(p.title)}</div>
              <div class="sr-meta">${escapeHtml(p.product_type)}</div>
            </div>
            <div class="sr-price">${formatMoney(p.price)}</div>
          </a>`;
      }).join('');
    } catch (e) {
      console.error('Search error:', e);
    }
  }, 250);
}

// ===================== SHOP FILTERS =====================
function filterShop(tag, btn) {
  document.querySelectorAll('.sf-btn').forEach((b) => b.classList.remove('on'));
  if (btn) btn.classList.add('on');

  var grouped = document.getElementById('groupedView');
  var flat = document.getElementById('productGrid');

  // If we have grouped + flat layout (collection page)
  if (grouped && flat) {
    if (tag === 'all') {
      grouped.style.display = '';
      flat.style.display = 'none';
      return;
    }
    grouped.style.display = 'none';
    flat.style.display = '';
    var cards = flat.querySelectorAll('.pc');
    cards.forEach(function(card) {
      var tags = (card.getAttribute('data-tags') || '').toLowerCase();
      if (tag === 'match') {
        var matchIds = JSON.parse(sessionStorage.getItem('oma_quiz_match_ids') || '[]');
        var pid = card.dataset.productId;
        card.style.display = matchIds.includes(pid) ? '' : 'none';
      } else {
        card.style.display = tags.indexOf(tag.toLowerCase()) > -1 ? '' : 'none';
      }
    });
    return;
  }

  // Fallback: simple filter on all .pc cards (non-collection pages)
  const allCards = document.querySelectorAll('.pc[data-tags]');
  if (tag === 'all') {
    allCards.forEach((c) => (c.style.display = ''));
    return;
  }
  if (tag === 'match') {
    const matchIds = JSON.parse(sessionStorage.getItem('oma_quiz_match_ids') || '[]');
    allCards.forEach((c) => {
      const pid = c.dataset.productId;
      c.style.display = matchIds.includes(pid) ? '' : 'none';
    });
    return;
  }
  allCards.forEach((c) => {
    const tags = (c.dataset.tags || '').toLowerCase().split(',');
    c.style.display = tags.includes(tag.toLowerCase()) ? '' : 'none';
  });
}

// ===================== QUIZ =====================
let qS = 1;
let qAnswers = {};
let quizDone = false;
let quizPath = 'self';
let q4Trigger = 'fragrance';
var quizProducts = [];

// --- Product handle + variant lookup ---
var QV = {
  "uto-10": {
    "h": "uto",
    "v": 54405349212532
  },
  "uto-50": {
    "h": "uto",
    "v": 54405349245300
  },
  "ifuru-10": {
    "h": "ifuru",
    "v": 54405350130036
  },
  "ifuru-50": {
    "h": "ifuru",
    "v": 54405350162804
  },
  "mod-perfume-10": {
    "h": "mod-perfume",
    "v": 54405356519796
  },
  "mod-perfume-50": {
    "h": "mod-perfume",
    "v": 54405356552564
  },
  "ubi-10": {
    "h": "ubi",
    "v": 54405351014772
  },
  "ubi-50": {
    "h": "ubi",
    "v": 54405351047540
  },
  "uto-bo-17": {
    "h": "uto-body-oil",
    "v": 54405378670964
  },
  "uto-bo-4": {
    "h": "uto-body-oil",
    "v": 54405378703732
  },
  "mod-bo-17": {
    "h": "mod-body-oil",
    "v": 54405362745716
  },
  "mod-bo-4": {
    "h": "mod-body-oil",
    "v": 54405362778484
  },
  "as-bo-17": {
    "h": "amalfi-sunrise-body-oil",
    "v": 54405358879092
  },
  "as-bo-4": {
    "h": "amalfi-sunrise-body-oil",
    "v": 54405358911860
  },
  "ig-bo-17": {
    "h": "imperial-garden-body-oil",
    "v": 54405361271156
  },
  "ig-bo-4": {
    "h": "imperial-garden-body-oil",
    "v": 54405361303924
  },
  "sahel-5": {
    "h": "sahel",
    "v": 54405378769268
  },
  "sahel-refill": {
    "h": "sahel",
    "v": 54405378802036
  },
  "resolve": {
    "h": "resolve",
    "v": 54405378867572
  },
  "grace": {
    "h": "grace",
    "v": 54405381456244
  },
  "as-sg": {
    "h": "amalfi-sunrise-shower-gel",
    "v": 54405381489012
  },
  "ed-sg": {
    "h": "mod-shower-gel",
    "v": 54405382504820
  },
  "as-ss": {
    "h": "amalfi-sunrise-shower-steamers",
    "v": 54405382570356
  },
  "ed-ss": {
    "h": "emerald-dream-shower-steamers",
    "v": 54405382603124
  },
  "as-candle": {
    "h": "amalfi-sunrise-candle",
    "v": 54405382537588
  },
  "osisi-10": {
    "h": "osisi",
    "v": 56293266588020
  },
  "osisi-50": {
    "h": "osisi",
    "v": 56293266620788
  }
};
var PERF_ADJ = {
  "warm": [
    "uto-10",
    "osisi-10"
  ],
  "fresh": [
    "mod-perfume-10",
    "osisi-10"
  ],
  "floral": [
    "ifuru-10",
    "ubi-10"
  ],
  "clean": [
    "ubi-10",
    "mod-perfume-10"
  ]
};
var GIFT_PERF_ALT = {
  "presence": [
    "ifuru-10",
    "ubi-10"
  ],
  "effortless": [
    "mod-perfume-10",
    "ubi-10"
  ],
  "soft_warm": [
    "uto-10",
    "osisi-10"
  ],
  "not_sure": [
    "ubi-10",
    "mod-perfume-10"
  ]
};
function getRitualBody(scent, q4) {
  if (scent === 'warm') return (q4 === 'has_signature' || q4 === 'switches_moods') ? 'sahel-5' : 'uto-bo-17';
  if (scent === 'fresh') return 'as-bo-17';
  if (scent === 'floral') return 'ig-bo-17';
  if (scent === 'clean') return (q4 === 'has_signature') ? 'sahel-5' : 'mod-bo-17';
  return 'as-bo-17';
}

// Shower product by scent family
function getShowerProduct(scent) {
  if (scent === 'warm') return 'ed-sg';
  if (scent === 'fresh') return 'as-sg';
  if (scent === 'floral') return 'ed-sg';
  if (scent === 'clean') return 'ed-sg';
  return 'ed-sg';
}

var QUIZ_RECS = {
  "self_warm_has_signature": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "uto-50"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to warmth and depth. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_warm_switches_moods": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "uto-10",
          "osisi-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "uto-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to warmth and depth. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_warm_still_searching": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "uto-10",
          "osisi-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "uto-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to warmth and depth. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_warm_hasnt_found_one": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "uto-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "uto-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to warmth and depth. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_fresh_has_signature": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "mod-perfume-50",
          "osisi-50"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "as-ss"
        ]
      }
    ],
    "copy": "You are drawn to bright openings and aromatic character. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_fresh_switches_moods": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "mod-perfume-10",
          "osisi-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "as-sg"
        ]
      }
    ],
    "copy": "You are drawn to bright openings and aromatic character. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_fresh_still_searching": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "mod-perfume-10",
          "osisi-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "as-sg"
        ]
      }
    ],
    "copy": "You are drawn to bright openings and aromatic character. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_fresh_hasnt_found_one": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "mod-perfume-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "as-sg"
        ]
      }
    ],
    "copy": "You are drawn to bright openings and aromatic character. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_floral_has_signature": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ifuru-50"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "ig-bo-4"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to expressive botanical florals. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_floral_switches_moods": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ifuru-10",
          "ubi-50"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "ig-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to expressive botanical florals. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_floral_still_searching": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ifuru-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "ig-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to expressive botanical florals. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_floral_hasnt_found_one": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ifuru-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "ig-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to expressive botanical florals. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_clean_has_signature": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to airy florals and an understated impression. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_clean_switches_moods": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ubi-10",
          "mod-perfume-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "mod-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to airy florals and an understated impression. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_clean_still_searching": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ubi-10",
          "mod-perfume-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "mod-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to airy florals and an understated impression. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_clean_hasnt_found_one": {
    "sections": [
      {
        "label": "Your scent",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "ubi-10"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "mod-bo-17"
        ]
      },
      {
        "label": "Complete the ritual",
        "intro": "One scent the whole way through.",
        "items": [
          "ed-sg"
        ]
      }
    ],
    "copy": "You are drawn to airy florals and an understated impression. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_skin_calm_and_clear": {
    "sections": [
      {
        "label": "For your skin",
        "intro": "What your skin is asking for.",
        "items": [
          "resolve"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "While you're caring for your skin — two scents worth trying while you do it.",
        "items": [
          "_PERF_ADJ_"
        ]
      }
    ],
    "copy": "You've probably tried enough things that promised to fix your skin. RESOLVE doesn't promise to fix anything — it's 18 botanicals formulated to work with what your skin is already doing, not against it. No stripping, no over-drying. SAHEL alongside it brings the same care to your whole body — because your skin doesn't stop at your face."
  },
  "self_skin_glow_and_evenness": {
    "sections": [
      {
        "label": "For your skin",
        "intro": "What your skin is asking for.",
        "items": [
          "grace"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "While you're caring for your skin — two scents worth trying while you do it.",
        "items": [
          "_PERF_ADJ_"
        ]
      }
    ],
    "copy": "Dull skin isn't a discipline problem. It's usually a formulation problem — the wrong ingredients, or the right ones in the wrong concentrations. GRACE has prickly pear seed oil, marula, and frankincense — some of the rarest oils we use — specifically for glow and evenness. SAHEL extends that same philosophy from your face to the rest of your skin."
  },
  "self_skin_moisture_and_softness": {
    "sections": [
      {
        "label": "For your skin",
        "intro": "What your skin is asking for.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "uto-bo-17"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "While you're caring for your skin — two scents worth trying while you do it.",
        "items": [
          "_PERF_ADJ_"
        ]
      }
    ],
    "copy": "Explore a scent that feels like your own. "
  },
  "self_skin_aging": {
    "sections": [
      {
        "label": "For your skin",
        "intro": "What your skin is asking for.",
        "items": [
          "grace"
        ]
      },
      {
        "label": "Your ritual",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "While you're caring for your skin — two scents worth trying while you do it.",
        "items": [
          "_PERF_ADJ_"
        ]
      }
    ],
    "copy": "You're not trying to look younger. You're trying to look like yourself, for longer. GRACE has prickly pear seed oil and frankincense — firmness and glow without the aggression. SAHEL extends that same philosophy to your whole body. Together they're a complete routine built around what your skin actually needs."
  },
  "self_discovery_needs_scent": {
    "sections": [
      {
        "label": "Start here",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "osisi-10",
          "ubi-10"
        ]
      }
    ],
    "copy": "Explore a scent that feels like your own. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_discovery_needs_skin": {
    "sections": [
      {
        "label": "Start here",
        "intro": "What your skin is asking for.",
        "items": [
          "resolve"
        ]
      },
      {
        "label": "Add this",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "And when your skin feels like itself again — something to wear.",
        "items": [
          "osisi-10",
          "ubi-10"
        ]
      }
    ],
    "copy": "Explore a scent that feels like your own. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_discovery_needs_ritual": {
    "sections": [
      {
        "label": "Start here",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "as-ss"
        ]
      },
      {
        "label": "Add this",
        "intro": "The body ritual that carries the same feeling all day.",
        "items": [
          "as-sg",
          "as-bo-17"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "The scent that carries the ritual past the shower.",
        "items": [
          "mod-perfume-10"
        ]
      }
    ],
    "copy": "Explore a scent that feels like your own. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_discovery_starting_fresh": {
    "sections": [
      {
        "label": "Start here",
        "intro": "Based on what you reach for — here's where to start.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "Something to wear",
        "intro": "When you're ready for a scent — start here.",
        "items": [
          "mod-perfume-10"
        ]
      }
    ],
    "copy": "Explore a scent that feels like your own. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_presence_fragrance_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ifuru-10"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_presence_fragrance_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ifuru-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ig-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_presence_fragrance_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ifuru-50"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_effortless_fragrance_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "mod-perfume-10"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ubi-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_effortless_fragrance_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_effortless_fragrance_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-perfume-50"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_soft_warm_fragrance_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "uto-10"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-bo-17"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_soft_warm_fragrance_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "uto-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "osisi-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_soft_warm_fragrance_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "uto-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_not_sure_fragrance_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "mod-perfume-10"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-perfume-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_not_sure_fragrance_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-10"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_not_sure_fragrance_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ifuru-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_skincare_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      },
      {
        "label": "Or start her scent journey instead",
        "intro": "If you want something more personal than a card — here are two scents matched to who she is.",
        "items": [
          "_GIFT_PERF_ALT_"
        ]
      }
    ],
    "copy": "SAHEL is a whole-skin crème built for daily use — face to feet, one formula, serious ingredients without any of the residue. She'll reach for it every morning. The gift card alongside means she can choose the rest of her routine herself — because she knows her skin better than anyone."
  },
  "gift_skincare_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      },
      {
        "label": "Or start her scent journey instead",
        "intro": "If you want something more personal than a card — here are two scents matched to who she is.",
        "items": [
          "_GIFT_PERF_ALT_"
        ]
      }
    ],
    "copy": "SAHEL is the most considered thing we make. Rich, non-greasy, built around ingredients most brands save exclusively for the face. The gift card alongside it means she gets the treat and the freedom to choose what comes next — on her terms."
  },
  "gift_skincare_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "sahel-refill"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      },
      {
        "label": "Or start her scent journey instead",
        "intro": "If you want something more personal than a card — here are two scents matched to who she is.",
        "items": [
          "_GIFT_PERF_ALT_"
        ]
      }
    ],
    "copy": "She knows exactly what she'd want for her skin. She just hasn't bought it yet. A gift card gives her exactly that — no compromise, no guessing. The SAHEL refill pod alongside it means she never runs out of the one thing she already loves."
  },
  "gift_presence_both_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ig-bo-17"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ifuru-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_presence_both_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ifuru-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ig-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. IFURU pairs rose and golden champaca with blackcurrant, clementine and soft ambrette. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_presence_both_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_effortless_both_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "mod-bo-17"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-perfume-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_effortless_both_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "mod-perfume-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_effortless_both_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "ubi-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_soft_warm_both_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "uto-bo-17"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_soft_warm_both_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "uto-50"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-bo-4"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_soft_warm_both_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-50"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_not_sure_both_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "mod-perfume-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_not_sure_both_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "sahel-5"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "ubi-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. UBI is a white garden of gardenia, white lotus, lily of the valley and blue lotus. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_not_sure_both_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "You know her well enough to know she won't spend this on herself. A gift card means she gets exactly what she'd want, no compromise. That's not a cop-out — that's knowing her."
  },
  "gift_neither_everyday": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "as-sg"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "as-bo-17"
        ]
      },
      {
        "label": "Curious about scent?",
        "intro": "These are the easiest place to start.",
        "items": [
          "mod-perfume-10"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_neither_real_treat": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "as-ss"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "as-sg",
          "as-bo-17"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      },
      {
        "label": "Curious about scent?",
        "intro": "These are the easiest place to start.",
        "items": [
          "mod-perfume-10",
          "uto-10"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. MOD opens with bright citrus and pepper, settling into tobacco, leather, clove and vanilla. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "gift_neither_never_justify": {
    "sections": [
      {
        "label": "For her",
        "intro": "What you described — matched to what we make.",
        "items": [
          "osisi-10"
        ]
      },
      {
        "label": "To complete it",
        "intro": "The thing that makes the first gift better.",
        "items": [
          "uto-10"
        ]
      },
      {
        "label": "Something to set the mood",
        "intro": "A candle that sets the whole ritual in motion.",
        "items": [
          "as-candle"
        ]
      }
    ],
    "copy": "A thoughtful place to begin their scent wardrobe. OSISI brings bergamot and ginger into hinoki, cypress, vetiver and warm sandalwood. UTÓ blends bright citrus and cardamom with cacao, golden beeswax and creamy vanilla. Choose a 10 ml bottle to explore, or 50 ml when you have found your favourite."
  },
  "self_experience": {
    "sections": [],
    "copy": "You don't want a product — you want a moment that's completely yours. The Signature Workshop brings the full experience to your space. You'll explore five fragrance families, learn how scent works with your body chemistry, and leave with a custom 10ml natural perfume you blended yourself.",
    "isExperience": true
  },
  "gift_experience": {
    "sections": [],
    "copy": "This one deserves more than a product. Let's talk.",
    "isExperience": true
  },
  "gift_not_sure_both_experience": {
    "sections": [],
    "copy": "This one deserves more than a product. Let's talk.",
    "isExperience": true
  },
  "gift_not_sure_experience_special": {
    "sections": [],
    "copy": "She'll blend her own. The best gift for someone you can't quite read.",
    "isExperience": true
  },
  "gift_skincare_experience": {
    "sections": [],
    "copy": "The Signature Workshop. She'll make her own perfume. Nothing more personal than that.",
    "isExperience": true
  },
  "gift_neither_experience": {
    "sections": [],
    "copy": "She'll blend her own perfume. The perfect first encounter with Oma.",
    "isExperience": true
  }
};
var OMA_QUIZ_VERSION = 'holiday-five-2026-10-09';
try { if (sessionStorage.getItem('oma_quiz_version') !== OMA_QUIZ_VERSION) { ['oma_quiz_done','oma_quiz_recs','oma_quiz_result_html','oma_quiz_match_ids','oma_quiz_match_handles'].forEach(function(key){sessionStorage.removeItem(key);}); sessionStorage.setItem('oma_quiz_version',OMA_QUIZ_VERSION); } } catch(e) {}

function openQuiz() {
  var qzo = document.getElementById('qzO'); if (!qzo) return;
  var isFullPage = qzo.classList.contains('qz-fullpage');
  var isProduct = document.body.classList.contains('is-product') || !!document.querySelector('.pd-panel');
  if (!isProduct && !isFullPage) { window.location.href = '/pages/scent-quiz'; return; }
  qzo.classList.add('on');
  if (!isFullPage) document.body.style.overflow = 'hidden';
  if (quizDone || sessionStorage.getItem('oma_quiz_done')) {
    quizDone = true;
    var savedResult = sessionStorage.getItem('oma_quiz_result_html');
    if (savedResult) {
      document.getElementById('qzResult').innerHTML = savedResult;
    }
    showStep('done');
    return;
  }
  qS = 1;
  showStep(1);
}

function closeQuiz() {
  document.getElementById('qzO').classList.remove('on');
  document.body.style.overflow = '';
}

function showStep(s) {
  document.querySelectorAll('.qs').forEach(function(el) { el.classList.remove('on'); });
  var nav = document.getElementById('qzNav');

  if (s === 'done') {
    document.querySelector('.qs[data-s="done"]').classList.add('on');
    nav.style.display = 'none';
    // Full progress bar
    document.querySelectorAll('.qz-bar').forEach(function(b) { b.classList.add('on'); });
    return;
  }

  // Find the right step element based on path
  var candidates = document.querySelectorAll('.qs[data-s="' + s + '"]');
  var target = null;
  candidates.forEach(function(el) {
    var p = el.getAttribute('data-path');
    var q4v = el.getAttribute('data-q4');
    if (!p) { target = el; return; } // shared step (Q1)
    if (p === quizPath) {
      if (s == 4 && quizPath === 'self') {
        if (q4v === q4Trigger) target = el;
      } else {
        if (!q4v) target = el;
      }
    }
  });

  if (target) target.classList.add('on');

  // Nav: show only on email step (5)
  nav.style.display = s === 5 ? 'flex' : 'none';
  var backBtn = document.getElementById('qzBackBtn');
  if (backBtn) backBtn.style.display = s > 1 && s <= 5 ? '' : 'none';
  // back button handled by qzBackBtn

  // Progress bar
  document.querySelectorAll('.qz-bar').forEach(function(b, i) {
    b.classList.toggle('on', i < s);
  });

  // Update email step copy based on path
  if (s === 5) {
    var eq = document.getElementById('qzEmailQ');
    if (eq) {
      eq.textContent = quizPath === 'gift'
        ? 'We found something she\'ll love. Where should we send it?'
        : 'Where should we send your match & 20% off?';
    }
  }
}

function pickO(el, step) {
  el.parentElement.querySelectorAll('.qs-o').forEach(function(o) { o.classList.remove('sel'); });
  el.classList.add('sel');
  qAnswers[step] = el.dataset.val;

  // After Q1, set path
  if (step === '1') {
    quizPath = el.dataset.val === 'gift' ? 'gift' : 'self';
    sessionStorage.setItem('quiz_gift_buyer', quizPath === 'gift' ? 'true' : 'false');
  }

  // After Q3 on self path, determine Q4 version
  if (step === '3' && quizPath === 'self') {
    var q2 = qAnswers['2'] || '';
    var q3 = qAnswers['3'] || '';
    // Q4C fires when Q2 = something_different (regardless of Q3)
    if (q2 === 'something_different') {
      q4Trigger = 'discovery';
    } else if (q3 === 'clean' && (q2 === 'take_care_of_myself' || q2 === 'put_together')) {
      q4Trigger = 'skin';
    } else {
      q4Trigger = 'fragrance';
    }
  }

  // Auto-advance for Q1-Q4
  if (parseInt(step) <= 4) {
    setTimeout(function() { qS++; showStep(qS); }, 350);
  }
}

function qzNext() {
  if (qS === 5) {
    var firstName = document.getElementById('qzFirstName').value.trim();
    var lastName = document.getElementById('qzLastName') ? document.getElementById('qzLastName').value.trim() : '';
    var email = document.getElementById('qzEmail').value.trim();
    if (!firstName || !email) {
      alert('Please fill in your first name and email to get your results.');
      return;
    }
    if (!email.includes('@') || !email.includes('.')) {
      alert('Please enter a valid email address.');
      return;
    }
    saveQuizCustomer(firstName, lastName, email);
    buildQuizRecs();
    pushQuizKlaviyo(firstName, lastName, email);
    quizDone = true;
    sessionStorage.setItem('oma_quiz_done', 'true');
    showStep('done');
    var matchFilter = document.getElementById('matchFilter');
    if (matchFilter) matchFilter.style.display = '';
    return;
  }
  if (qS <= 5) { qS++; showStep(qS); }
}

function qzBack() {
  if (qS > 1) { qS--; showStep(qS); }
}

async function saveQuizCustomer(firstName, lastName, email) {
  try {
    var formData = new FormData();
    formData.append('form_type', 'customer');
    formData.append('utf8', '\u2713');
    formData.append('customer[first_name]', firstName);
    formData.append('customer[last_name]', lastName);
    formData.append('customer[email]', email);
    formData.append('customer[tags]', 'quiz-lead,mymatch20');
    var noteStr = 'Quiz v2: path=' + quizPath;
    for (var k in qAnswers) { noteStr += ', q' + k + '=' + qAnswers[k]; }
    formData.append('customer[note]', noteStr);
    await fetch('/contact#contact_form', { method: 'POST', body: formData });
  } catch(e) { console.log('Customer save error:', e); }
}

function pushQuizKlaviyo(firstName, lastName, email) {
  var _learnq = window._learnq || [];
  var scentMap = { warm: 'warm_earthy', fresh: 'fresh_botanical', floral: 'rich_floral', clean: 'clean_subtle' };

  var identifyProps = {
    '$email': email,
    '$first_name': firstName,
    '$last_name': lastName,
    'quiz_completed': true,
    'quiz_completed_at': new Date().toISOString(),
    'quiz_version': 'v2',
    'quiz_completion_count': (parseInt(localStorage.getItem('oma_quiz_count') || '0') + 1),
    'quiz_retaken': (parseInt(localStorage.getItem('oma_quiz_count') || '0') > 0),
    'quiz_shopping_for': quizPath
  };

  if (quizPath === 'self') {
    var scent = qAnswers['3'] || '';
    identifyProps['pref_aspiration'] = qAnswers['2'] || '';
    identifyProps['pref_scent_instinct'] = scent;
    identifyProps['pref_scent_family'] = scentMap[scent] || scent;
    identifyProps['quiz_q4_trigger'] = q4Trigger;
    if (q4Trigger === 'fragrance') identifyProps['pref_fragrance_relationship'] = qAnswers['4'] || '';
    if (q4Trigger === 'skin') identifyProps['pref_skin_concern'] = qAnswers['4'] || '';
    if (q4Trigger === 'discovery') identifyProps['pref_routine_gap'] = qAnswers['4'] || '';
  } else {
    identifyProps['flag_gift_purchaser'] = true;
    identifyProps['gift_recipient_character'] = qAnswers['2'] || '';
    identifyProps['gift_recipient_world'] = qAnswers['3'] || '';
    identifyProps['gift_intent'] = qAnswers['4'] || '';
  }

  if (qAnswers['4'] === 'experience') {
    identifyProps['flag_experience_lead'] = true;
  }

  identifyProps['customer_stage'] = 'lead';
  identifyProps['has_purchased_quiz_rec'] = false;

  _learnq.push(['identify', identifyProps]);

  // Track event
  var eventProps = Object.assign({}, identifyProps);
  delete eventProps['$email'];
  delete eventProps['$first_name'];
  _learnq.push(['track', 'Oma Quiz Completed', eventProps]);
  localStorage.setItem('oma_quiz_count', String((parseInt(localStorage.getItem('oma_quiz_count') || '0') + 1)));

  // dataLayer push
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'oma:quiz_completed', oma_data: eventProps });

  // Gift buyer event
  if (quizPath === 'gift') {
    _learnq.push(['track', 'Oma Quiz Gift Buyer', { quiz_gift_buyer: true, timestamp: new Date().toISOString() }]);
  }


  // Klaviyo Client Subscribe API — ensure profile is on the Email List
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Uj3Gnx', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-07-15' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Scent Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                last_name: lastName,
                properties: {
                  quiz_completed: true,
                  quiz_version: 'v2',
                  customer_stage: 'lead'
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: 'UU3JQD' } }
        }
      }
    })
  }).catch(function() {});
}

// ==========================================
// BUILD RECOMMENDATIONS
// ==========================================
function getRecKey() {
  var q2 = qAnswers['2'] || '';
  var q3 = qAnswers['3'] || '';
  var q4 = qAnswers['4'] || '';

  // Experience routing
  if (q4 === 'experience') {
    if (quizPath === 'self') return 'self_experience';
    if (q3 === 'skincare') return 'gift_skincare_experience';
    if (q3 === 'neither') return 'gift_neither_experience';
    if (q2 === 'not_sure' && q3 === 'both') return 'gift_not_sure_experience_special';
    return 'gift_experience';
  }

  if (quizPath === 'self') {
    if (q4Trigger === 'fragrance') return 'self_' + q3 + '_' + q4;
    if (q4Trigger === 'skin') return 'self_skin_' + q4;
    if (q4Trigger === 'discovery') return 'self_discovery_' + q4;
  }

  // Gift path
  if (q3 === 'skincare') return 'gift_skincare_' + q4;
  if (q3 === 'neither') return 'gift_neither_' + q4;
  // fragrance or both: key includes Q2
  return 'gift_' + q2 + '_' + q3 + '_' + q4;
}

function buildQuizRecs() {
  // Load product data
  try {
    var dataEl = document.getElementById('quiz-products-data');
    if (dataEl) {
      var rawText = dataEl.textContent;
      // Clean any Liquid errors from the JSON
      rawText = rawText.replace(/Liquid error[^"]*"/g, '""');
      rawText = rawText.replace(/Liquid err[^"]*"/g, '""');
      quizProducts = JSON.parse(rawText);
    }
  } catch(e) { console.error('Quiz product data error:', e); }

  var key = getRecKey();
  var rec = QUIZ_RECS[key];
  if (!rec) {
    console.warn('No quiz rec found for key:', key);
    return;
  }

  // Set headline
  var headline = document.getElementById('qzHeadline');
  if (headline) {
    if (rec.isExperience) {
      headline.textContent = quizPath === 'gift' ? 'We have something special in mind.' : 'We have something special in mind.';
    } else {
      headline.textContent = quizPath === 'gift' ? 'Here\'s what we found for her.' : 'Here\'s what we found for you.';
    }
  }

  // Set copy
  var copyEl = document.getElementById('qzCopy');
  if (copyEl) copyEl.textContent = rec.copy;

  var recsEl = document.getElementById('qzRecs');

  // Experience routing
  if (rec.isExperience) {
    recsEl.innerHTML = '<a class="btn btn-dark" style="margin-top:20px;display:inline-block;" href="/pages/experiences" onclick="closeQuiz()"><span>' + (quizPath === 'gift' ? 'Book her an Experience \u2192' : 'Inquire about an Experience \u2192') + '</span></a>';
    // Hide add-all button
    var addAllBtn = document.getElementById('qzAddAll');
    if (addAllBtn) addAllBtn.style.display = 'none';
    sessionStorage.setItem('oma_quiz_result_html', document.getElementById('qzResult').innerHTML);
    return;
  }

  // Build product cards (flat list)
  var html = '';
  var allVariantIds = [];
  var scent = qAnswers['3'] || 'warm';
  var allItems = [];

  rec.sections.forEach(function(section) {
    var items = [];
    section.items.forEach(function(item) {
      if (item === '_PERF_ADJ_') {
        var adj = PERF_ADJ[scent] || PERF_ADJ['warm'];
        items = items.concat(adj);
      } else if (item === '_GIFT_PERF_ALT_') {
        var q2 = qAnswers['2'] || 'not_sure';
        var alt = GIFT_PERF_ALT[q2] || GIFT_PERF_ALT['not_sure'];
        items = items.concat(alt);
      } else {
        items.push(item);
      }
    });
    allItems = allItems.concat(items);
  });

  var seen = {};
  allItems = allItems.filter(function(k) { if (seen[k]) return false; seen[k] = true; return true; });

  allItems.forEach(function(itemKey) {
    var qvEntry = QV[itemKey];
    if (!qvEntry) return;
    var prod = quizProducts.find(function(p) { return p.handle === qvEntry.h; });
    if (!prod) return;
    // Skip if variant is unavailable
    var variant = prod.variants ? prod.variants.find(function(v) { return v.id === qvEntry.v; }) : null;
    if (!variant || variant.available === false) return;
    if (/perfume/i.test(prod.type || '') && ['ifuru','ubi','osisi','uto','mod-perfume'].indexOf(prod.handle) === -1) return;
    var price = variant ? variant.price_formatted : prod.price_formatted;
    var variantId = qvEntry.v;
    allVariantIds.push(variantId);

    var image = variant.image || prod.image;
    var productUrl = prod.url + (prod.url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
    var imgHtml = image ? '<img src="' + image + '" alt="' + escapeHtml(prod.title + ' ' + variant.title) + '">' : '';
    var typeStr = prod.type || '';

    html += '<div class="qz-rec">' +
      '<a class="qz-rec-img" href="' + productUrl + '" onclick="closeQuiz()">' + imgHtml + '</a>' +
      '<a style="flex:1;text-decoration:none;color:inherit;" href="' + productUrl + '" onclick="closeQuiz()">' +
      '<div class="qz-rec-name">' + escapeHtml(prod.title) + '</div>' +
      '<div class="qz-rec-why">' + escapeHtml(typeStr) + '</div>' +
      '</a>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;">' +
      '<div class="qz-rec-price">' + price + '</div>' +
      '<button class="qz-rec-cart" onclick="quizAddToCart(this,' + variantId + ')">Add to Cart</button>' +
      '</div></div>';
  });

  recsEl.innerHTML = html || '<p>These matches are currently unavailable. Please browse the collection for more options.</p>';
  var addAllBtn = document.getElementById('qzAddAll');
  if (addAllBtn) addAllBtn.style.display = allVariantIds.length ? '' : 'none';

  window._quizRecVariantIds = allVariantIds;
  sessionStorage.setItem('oma_quiz_match_ids', JSON.stringify(allVariantIds));

  var recHandles = allVariantIds.map(function(vid) {
    for (var k in QV) { if (QV[k].v === vid) return QV[k].h; }
    return '';
  }).filter(Boolean);
  sessionStorage.setItem('oma_quiz_match_handles', JSON.stringify(recHandles));

  var _learnq = window._learnq || [];
  var email = document.getElementById('qzEmail') ? document.getElementById('qzEmail').value.trim() : '';
  if (email) {
    var recProps = { '$email': email, 'quiz_rec_products': recHandles.join(',') };
    if (recHandles[0]) recProps['quiz_rec_primary'] = recHandles[0];
    if (recHandles[1]) recProps['quiz_rec_secondary'] = recHandles[1];
    _learnq.push(['identify', recProps]);
  }

  sessionStorage.setItem('oma_quiz_result_html', document.getElementById('qzResult').innerHTML);
}

function quizAddToCart(btn, variantId) {
  btn.textContent = "Adding...";
  btn.disabled = true;
  btn.style.opacity = "0.6";
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  }).then(function() {
    btn.textContent = "✓ Added!";
    btn.style.background = "#22c55e";
    btn.style.opacity = "1";
    // Update cart count
    fetch("/cart.js").then(function(r) { return r.json(); }).then(function(c) { updateCartCount(c.item_count); });
    // Fade out the card after a moment
    setTimeout(function() {
      var card = btn.closest(".qz-rec");
      if (card) {
        card.style.transition = "opacity 0.4s, max-height 0.4s";
        card.style.opacity = "0.4";
      }
    }, 1500);
  }).catch(function() {
    btn.textContent = "Retry";
    btn.style.opacity = "1";
    btn.disabled = false;
  });
}

function addAllQuizRecs() {
  var ids = window._quizRecVariantIds || [];
  if (!ids.length) return;
  var btn = document.getElementById('qzAddAll');
  if (btn) btn.innerHTML = '<span>Adding...</span>';
  var addNext = function(i) {
    if (i >= ids.length) {
      if (btn) btn.innerHTML = '<span>\u2713 Added to cart!</span>';
      setTimeout(function() { closeQuiz(); openCart(); }, 1200);
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: ids[i], quantity: 1 })
    }).then(function() { addNext(i + 1); }).catch(function() { addNext(i + 1); });
  };
  addNext(0);
}

// Show match filter if quiz was completed in a previous page load
if (sessionStorage.getItem('oma_quiz_done')) {
  var matchFilter = document.getElementById('matchFilter');
  if (matchFilter) matchFilter.style.display = '';
}



function retakeQuiz() {
  sessionStorage.removeItem('oma_quiz_done');
  sessionStorage.removeItem('oma_quiz_recs');
  sessionStorage.removeItem('oma_quiz_result_html');
  sessionStorage.removeItem('oma_quiz_match_ids');
  sessionStorage.removeItem('oma_quiz_match_handles');
  quizDone = false;
  qS = 1;
  qAnswers = {};
  quizPath = 'self';
  q4Trigger = 'fragrance';
  showStep(1);
}

// Anchor bar: smooth scroll + active highlight on scroll
function smoothTo(e, id) {
  e.preventDefault();
  var el = document.getElementById(id);
  if (el) {
    var offset = 120;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
}

(function() {
  var anchors = document.querySelectorAll('.pp-anchor');
  if (!anchors.length) return;

  var sectionIds = ['pd-details', 'pd-ingredients', 'whats-inside', 'wear-profile', 'if-youve-worn'];

  function updateActive() {
    var scrollY = window.scrollY + 140;
    var activeId = '';

    for (var i = sectionIds.length - 1; i >= 0; i--) {
      var el = document.getElementById(sectionIds[i]);
      if (el && el.getBoundingClientRect().top + window.pageYOffset <= scrollY) {
        activeId = sectionIds[i];
        break;
      }
    }

    anchors.forEach(function(a) {
      var href = a.getAttribute('href') || '';
      var id = href.replace('#', '');
      a.classList.toggle('active', id === activeId);
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() { updateActive(); ticking = false; });
      ticking = true;
    }
  });
  updateActive();
})();



// Scent Discovery Kit — auto-add/remove logic
var SDK_VARIANT = 54575310471540;
var SDK_HANDLE = 'scent-discovery-kit';
var PERFUME_HANDLES = ["ahihia","ifuru","ikuku","mod-perfume","solaire","ubi","uto","good-scents-discovery-set"];

function sdkCheckCart(cart) {
  if (!cart || !cart.items) return;

  var hasPerfume = false;
  var hasKit = false;
  var kitKey = '';
  var hasNonKitItems = false;

  cart.items.forEach(function(item) {
    if (PERFUME_HANDLES.indexOf(item.handle) > -1) hasPerfume = true;
    if (item.handle === SDK_HANDLE) { hasKit = true; kitKey = item.key; }
    if (item.handle !== SDK_HANDLE) hasNonKitItems = true;
  });

  // Free Scent Discovery Kit auto-add is DISABLED: the kit variant is out of stock, so the add
  // returned 422 on every non-perfume add (and could leave a kit that re-adds itself). The cleanup
  // below still removes a stray kit when a perfume is present or the cart is otherwise kit-only.
  if ((hasPerfume || !hasNonKitItems) && hasKit) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: kitKey, quantity: 0 })
    }).then(function() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
        updateCartCount(c.item_count);
        renderCartDrawer(c);
      });
    });
  }
}

// SDK page-load check — auto-add kit if needed
(function() {
  fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
    sdkCheckCart(cart);
  }).catch(function() {});
})();


// ===================== QUIZ REWARD (one-time first-order offer) =====================
// The scent-quiz code (MYMATCH20) is already once-per-customer server-side. Here we stop
// showing the 20%-off promos once a shopper has EARNED it (finished the quiz) AND taken it
// to checkout — so returning/repeat shoppers don't keep seeing an offer they've used.
window.omaReward = {
  earned: function(){ try { return localStorage.getItem('oma_reward_earned') === '1'; } catch(e){ return false; } },
  used:   function(){ try { return localStorage.getItem('oma_reward_used') === '1'; } catch(e){ return false; } },
  markEarned: function(){ try { localStorage.setItem('oma_reward_earned','1'); } catch(e){} },
  markUsed: function(){ try { localStorage.setItem('oma_reward_used','1'); } catch(e){} this.hide(); },
  hide: function(){ if(!this.used()) return; try { document.querySelectorAll('[data-quiz-offer]').forEach(function(el){ el.style.display='none'; }); } catch(e){} }
};
document.addEventListener('DOMContentLoaded', function(){ window.omaReward.hide(); });
setTimeout(function(){ if(window.omaReward) window.omaReward.hide(); }, 1200);

// ===================== FAQ =====================
function toggleFaq(el) {
  el.parentElement.classList.toggle('open');
}

// ===================== UTILITIES =====================
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

function escapeHtml(str) {
  const div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function getSizedImageUrl(url, size) {
  if (!url) return '';
  // Shopify image URL sizing
  const match = url.match(/(.+)(\.[a-z]+)(\?.*)?$/i);
  if (match) {
    return match[1] + '_' + size + match[2] + (match[3] || '');
  }
  return url;
}


// === Post-purchase: set has_purchased_* booleans + lifecycle stage ===
(function() {
  if (!window.Shopify || !window.Shopify.checkout) return;
  var _learnq = window._learnq || [];
  var items = window.Shopify.checkout.line_items || [];
  var types = items.map(function(i){return i.product_type || ''});

  var props = {};
  if (types.indexOf('Perfume') > -1) props.has_purchased_perfume = true;
  if (types.indexOf('Body Oil') > -1 || types.indexOf('Body Crème') > -1) props.has_purchased_body_oil = true;
  if (types.indexOf('Face Oil') > -1) props.has_purchased_face_oil = true;
  if (types.indexOf('Shower Gel') > -1 || types.indexOf('Shower Steamer') > -1 || types.indexOf('Candle') > -1) props.has_purchased_ritual = true;

  // Lifecycle stage
  var orderCount = parseInt(localStorage.getItem('oma_order_count') || '0') + 1;
  localStorage.setItem('oma_order_count', String(orderCount));
  var prevStage = localStorage.getItem('oma_customer_stage') || 'lead';
  var newStage = orderCount === 1 ? 'first_purchase' : orderCount >= 3 ? 'vip' : 'repeat_buyer';

  // Reactivation: if they were lapsed and came back
  var reactivationCount = parseInt(localStorage.getItem('oma_reactivation_count') || '0');
  if (prevStage === 'lapsed' || prevStage === 'at_risk') {
    newStage = 'reactivated';
    reactivationCount++;
    localStorage.setItem('oma_reactivation_count', String(reactivationCount));
  }

  localStorage.setItem('oma_customer_stage', newStage);
  localStorage.setItem('oma_stage_changed_at', new Date().toISOString());

  props.customer_stage = newStage;
  props.customer_stage_updated = new Date().toISOString();
  props.reactivation_count = reactivationCount;
  props.total_orders = orderCount;

  // Check if gift purchase (from quiz)
  if (sessionStorage.getItem('quiz_gift_buyer') === 'true') {
    props.has_purchased_as_gift = true;
  }

  // Track wishlist conversion
  try {
    var wlCookie = document.cookie.split(';').find(function(c){return c.trim().startsWith('oma_wishlist=')});
    if (wlCookie) {
      var wl = JSON.parse(decodeURIComponent(wlCookie.split('=')[1]));
      items.forEach(function(item) {
        if (wl.some(function(w){return w.handle === item.handle})) {
          var purchased = parseInt(localStorage.getItem('oma_wl_purchased') || '0') + 1;
          localStorage.setItem('oma_wl_purchased', String(purchased));
        }
      });
    }
  } catch(e){}

  _learnq.push(['identify', props]);
})();

function syncVariantImageOnLoad() {
  var on = document.querySelector('.sz.on') || document.querySelector('.sz');
  if (!on) return; var img = on.getAttribute('data-variant-img'); var main = document.querySelector('.pd-main img') || document.querySelector('.pd-left img');
  if (img && main && main.src.indexOf(img.split('?')[0].split('/').pop()) < 0) { main.src = img; main.srcset = ''; }
}



function markPortraitPdImage() {
  var im = document.querySelector('.pd-main img'); if (!im) return;
  var f = function () { im.classList.toggle('is-portrait', im.naturalHeight > im.naturalWidth * 1.12); };
  if (im.complete) f(); else im.addEventListener('load', f);
}
document.addEventListener('DOMContentLoaded', markPortraitPdImage);

/* ===== Product media gallery (images + video, thumbnails, mobile swipe) ===== */
var PD_MEDIA = null;
function pdMediaData() { if (PD_MEDIA) return PD_MEDIA; try { PD_MEDIA = JSON.parse(document.getElementById('pd-media-data').textContent); } catch (e) { PD_MEDIA = []; } return PD_MEDIA; }
function pdShowImage(src) {
  var main = document.getElementById('pdMain'); if (!main) return;
  var im = main.querySelector('img');
  if (!im) { main.innerHTML = '<img alt="">'; im = main.querySelector('img'); }
  var vid = main.querySelector('video'); if (vid) { main.innerHTML = '<img alt="">'; im = main.querySelector('img'); }
  im.src = src; im.srcset = '';
  if (typeof markPortraitPdImage === 'function') { im.addEventListener('load', function h() { im.removeEventListener('load', h); markPortraitPdImage(); }); }
}
function pdSetMedia(idx) {
  var data = pdMediaData(); var m = data[idx]; var main = document.getElementById('pdMain'); if (!m || !main) return;
  if (m.type === 'image') { pdShowImage(m.full); }
  else if (m.type === 'video' && m.sources && m.sources.length) {
    main.innerHTML = '<video class="pd-main-video" playsinline muted loop controls autoplay preload="metadata" poster="' + (m.poster || '') + '">' +
      m.sources.map(function (s) { return '<source src="' + s.url + '" type="' + (s.mime || '') + '">'; }).join('') + '</video>';
    var v = main.querySelector('video'); if (v) { v.play && v.play().catch(function () {}); }
  } else if (m.type === 'external_video' && m.embed) {
    main.innerHTML = '<iframe class="pd-main-embed" src="' + m.embed + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen title="Product video"></iframe>';
  }
  var thumbs = document.querySelectorAll('#pdThumbs .pd-thumb');
  thumbs.forEach(function (t, i) { t.classList.toggle('on', i === idx); });
}
function pdGalleryInit() {
  var wrap = document.getElementById('pdThumbs'); if (!wrap) return;
  wrap.querySelectorAll('.pd-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () { pdSetMedia(parseInt(btn.getAttribute('data-idx'), 10) || 0); });
  });
}
document.addEventListener('DOMContentLoaded', pdGalleryInit);
window.addEventListener('load', function () { setTimeout(pdGalleryInit, 60); });

/* ---- Instant navigation: prefetch internal links on hover / touch (shop→product, home→quiz) ---- */
(function () {
  var seen = {};
  function prefetch(url) {
    if (seen[url]) return; seen[url] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = url; l.as = 'document';
    document.head.appendChild(l);
  }
  function onIntent(e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (!a || a.hostname !== location.hostname) return;        // same-origin only
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#' || a.hasAttribute('data-no-prefetch')) return;
    if (a.pathname === location.pathname) return;              // same page / in-page anchor
    if (/\.(jpg|jpeg|png|webp|gif|svg|pdf|zip|mp4|mov)(\?|$)/i.test(a.pathname)) return;
    prefetch(a.href);
  }
  var opt = { passive: true, capture: true };
  document.addEventListener('mouseover', onIntent, opt);       // desktop hover
  document.addEventListener('touchstart', onIntent, opt);      // mobile tap-intent
})();

/* ---- Discovery Set "pick 4 scents" builder ---- */
function omaScentPick(el){
  var chosen = document.querySelectorAll('.scent-pick.on');
  if (!el.classList.contains('on') && chosen.length >= 4) return; // cap at 4
  el.classList.toggle('on');
  syncScentPicks();
}
function syncScentPicks(){
  var picker = document.getElementById('scentPicker');
  if (!picker) return;
  var chosen = [].slice.call(document.querySelectorAll('.scent-pick.on'));
  for (var i = 1; i <= 4; i++){
    var inp = document.getElementById('scentProp' + i);
    if (inp) inp.value = chosen[i-1] ? chosen[i-1].getAttribute('data-scent') : '';
  }
  var c = document.getElementById('scentCount'); if (c) c.textContent = chosen.length;
  // dim the unselected once 4 are chosen
  var full = chosen.length >= 4;
  document.querySelectorAll('.scent-pick').forEach(function(b){ b.classList.toggle('sp-maxed', full && !b.classList.contains('on')); });
  var btn = document.querySelector('.btn-cart');
  if (btn){
    var ok = chosen.length === 4;
    btn.disabled = !ok;
    btn.classList.toggle('is-disabled', !ok);
    var lbl = btn.querySelector('.btn-cart-label') || btn;
    if (lbl.dataset) { if (ok) { lbl.textContent = lbl.dataset.ready || 'Add to Cart'; } else { lbl.textContent = 'Pick ' + (4 - chosen.length) + ' more'; } }
  }
}
document.addEventListener('DOMContentLoaded', function(){ if (document.getElementById('scentPicker')) syncScentPicks(); });

